import 'mutationobserver-shim';
import Vue from 'vue';
import VueMoment from 'vue-moment';
import VueRouter from 'vue-router';
import vuetify from './plugins/vuetify';
import router from './router';
import App from './components/App.vue';
import store from './store';

Vue.config.ignoredElements = [/amplify-\w*/];

Vue.use(VueMoment);
Vue.config.productionTip = false;
Vue.use(VueRouter);

new Vue({
    vuetify,
    store,
    router,
    render: (h) => h(App)
}).$mount('#app');
